import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import * as React from "react";

/**
 * DatePicker component.
 *
 * This component renders a date picker that allows users to select dates and updates the current value when selected.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {(Date | null)} props.currentVal - The currently selected date value.
 * @param {Function} props.handleVal - Callback function called when the date is changed, receiving the new date as an argument.
 * @param {boolean} [props.disabled=false] - Whether the date picker is disabled.
 *
 * @returns {JSX.Element} - The JSX element for the date picker.
 */
function DatePicker({ currentVal, handleVal, disabled = false }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <StaticDatePicker
        displayStaticWrapperAs="desktop"
        openTo="day"
        value={currentVal}
        disabled={disabled}
        onChange={(newValue) => {
          handleVal(newValue);
        }}
        slots={{
          textField: TextField,
        }}
      />
    </LocalizationProvider>
  );
}

export default DatePicker;
